import { toaster } from 'uikit/Toaster'
import { useMutation } from '@tanstack/react-query'
import { api } from 'api'
import { authStore } from 'shared/store/auth'

export const useAuth = () => {

  return useMutation({
    mutationFn: api.auth.me,
    onSuccess: (data) => {
      authStore.setState((state) => ({
        ...state,
        user: data,
        isAuthenticated: true,
      }))
    },
    onError: () => {
      toaster.create({
        title: 'Ошибка',
        description: 'Не удалось получить данные авторизации',
        type: 'error',
        closable: true,
      })
    },
  })
}
